"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logoutBaseTheme = function (_breakpoints) {
    return ({
        logout: {
            flex: "1",
            alignItems: "center",
            flexDirection: "column",
            display: "flex",
            paddingTop: "1rem"
        },
        logoutMessageWrapper: {
            fontSize: "1.5rem",
            flexDirection: "column",
            textAlign: "center"
        },
        logoutMessage: {
            fontSize: "1.5rem"
        },
        logoutSSOMessageWrapper: {},
        logoutSSOMessage: {},
        logoutLoginMessageWrapper: {},
        logoutLoginMessage: {},
    });
};
exports.default = logoutBaseTheme;
//# sourceMappingURL=logout.js.map